"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function dlt(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M11.8551 7.46847L7.28456 17.2237H14.8723C15.0921 17.2237 15.2908 17.3587 15.3771 17.565L15.3853 17.5837C15.4135 17.6509 15.4261 17.7236 15.4221 17.7964C15.418 17.8692 15.3975 17.94 15.3621 18.0037C15.3001 18.1157 15.2094 18.2091 15.0993 18.2743C14.9892 18.3396 14.8638 18.3743 14.7358 18.375H6.67181C6.54701 18.3747 6.4252 18.3368 6.32231 18.2662L6.28031 18.2377C6.15334 18.1491 6.06185 18.0184 6.02204 17.8687C5.98223 17.7191 5.99667 17.5602 6.06281 17.4202L11.4553 6.05847C11.5116 5.93997 11.5918 5.83497 11.6901 5.75097C11.7828 5.67101 11.9008 5.62641 12.0232 5.62503C12.1456 5.62366 12.2646 5.66561 12.3591 5.74347C12.402 5.77842 12.4366 5.82248 12.4603 5.87247L17.9301 17.3115C18.0051 17.4667 18.0201 17.6445 17.9736 17.811C17.9494 17.9016 17.896 17.9818 17.8217 18.0391C17.7475 18.0965 17.6564 18.1278 17.5626 18.1282H17.4996C17.3737 18.1275 17.2506 18.0906 17.1451 18.022C17.0395 17.9534 16.9559 17.8559 16.9041 17.7412L12.1866 7.46997C12.1723 7.43795 12.1492 7.41068 12.12 7.39141C12.0908 7.37213 12.0566 7.36165 12.0216 7.36122C11.9864 7.36123 11.9521 7.37135 11.9225 7.39037C11.893 7.40939 11.8696 7.4365 11.8551 7.46847Z", fill: color }));
}
exports["default"] = dlt;
//# sourceMappingURL=dlt.js.map